import { PlaylistItemDTO } from './view-models/playlist-item-models/playlist-item-dto.model';
import { PersonalDataViewModel } from './view-models/account-models/user-models/personal-data-view-model';
import { TransitionEffect } from '../constants/transition-effect.const';

export class LibraryEditItem {
  Id: number = null;
  Title: string = null;
  Description: string = null;
  IsShared: boolean = false;
  UsersWhoHaveAccessIds: string[] = [];

  MachinePhysicalAddress?: string = null;
  IsRepeated?: boolean = false;
  PlaylistItems?: PlaylistItemDTO[] = [];
  User?: PersonalDataViewModel;
  UserId?: string = null;
  CreatorUserId?: string = null;
  Color?: string = null;
  IsSharedWithAllUsers: boolean = false;
  IsAndroid?: boolean = false;
  Transition?: TransitionEffect = TransitionEffect.Cut;
  FitToVideoSize?: boolean = false;

  constructor(values: Partial<LibraryEditItem> = {}) {
    Object.assign(this, values);
  }
}
